import { render } from "./QuestionCard.vue?vue&type=template&id=7e37cfea&scoped=true&ts=true"
import script from "./QuestionCard.vue?vue&type=script&lang=ts"
export * from "./QuestionCard.vue?vue&type=script&lang=ts"

import "./QuestionCard.vue?vue&type=style&index=0&id=7e37cfea&scoped=true&lang=scss"

import exportComponent from "/tmp/plasty-fe-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e37cfea"]])

export default __exports__